function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*! maska v2.1.10 | (c) Alexander Shabunevich | Released under the MIT license */
var W = Object.defineProperty;

var b = function b(n, t, s) {
  return t in n ? W(n, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: s
  }) : n[t] = s;
};

var m = function m(n, t, s) {
  return b(n, _typeof(t) != "symbol" ? t + "" : t, s), s;
};

var O = {
  "#": {
    pattern: /[0-9]/
  },
  "@": {
    pattern: /[a-zA-Z]/
  },
  "*": {
    pattern: /[a-zA-Z0-9]/
  }
};

var w = /*#__PURE__*/function () {
  function w() {
    var _s$mask$;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, w);

    m(this, "opts", {});
    m(this, "memo", /* @__PURE__ */new Map());

    var s = _objectSpread({}, t);

    if (s.tokens != null) {
      s.tokens = s.tokensReplace ? _objectSpread({}, s.tokens) : _objectSpread(_objectSpread({}, O), s.tokens);

      for (var _i = 0, _Object$values = Object.values(s.tokens); _i < _Object$values.length; _i++) {
        var e = _Object$values[_i];
        typeof e.pattern == "string" && (e.pattern = new RegExp(e.pattern));
      }
    } else s.tokens = O;

    Array.isArray(s.mask) && (s.mask.length > 1 ? s.mask = _toConsumableArray(s.mask).sort(function (e, a) {
      return e.length - a.length;
    }) : s.mask = (_s$mask$ = s.mask[0]) !== null && _s$mask$ !== void 0 ? _s$mask$ : ""), s.mask === "" && (s.mask = null), this.opts = s;
  }

  _createClass(w, [{
    key: "masked",
    value: function masked(t) {
      return this.process(t, this.findMask(t));
    }
  }, {
    key: "unmasked",
    value: function unmasked(t) {
      return this.process(t, this.findMask(t), !1);
    }
  }, {
    key: "isEager",
    value: function isEager() {
      return this.opts.eager === !0;
    }
  }, {
    key: "isReversed",
    value: function isReversed() {
      return this.opts.reversed === !0;
    }
  }, {
    key: "completed",
    value: function completed(t) {
      var s = this.findMask(t);
      if (this.opts.mask == null || s == null) return !1;
      var e = this.process(t, s).length;
      return typeof this.opts.mask == "string" ? e >= this.opts.mask.length : typeof this.opts.mask == "function" ? e >= s.length : this.opts.mask.filter(function (a) {
        return e >= a.length;
      }).length === this.opts.mask.length;
    }
  }, {
    key: "findMask",
    value: function findMask(t) {
      var _s$slice$pop,
          _s$find,
          _this = this;

      var s = this.opts.mask;
      if (s == null) return null;
      if (typeof s == "string") return s;
      if (typeof s == "function") return s(t);
      var e = this.process(t, (_s$slice$pop = s.slice(-1).pop()) !== null && _s$slice$pop !== void 0 ? _s$slice$pop : "", !1);
      return (_s$find = s.find(function (a) {
        return _this.process(t, a, !1).length >= e.length;
      })) !== null && _s$find !== void 0 ? _s$find : "";
    }
  }, {
    key: "escapeMask",
    value: function escapeMask(t) {
      var s = [],
          e = [];
      return t.split("").forEach(function (a, i) {
        a === "!" && t[i - 1] !== "!" ? e.push(i - e.length) : s.push(a);
      }), {
        mask: s.join(""),
        escaped: e
      };
    }
  }, {
    key: "process",
    value: function process(t, s) {
      var _this2 = this;

      var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      var A;
      if (s == null) return t;
      var a = "value=".concat(t, ",mask=").concat(s, ",masked=").concat(e ? 1 : 0);
      if (this.memo.has(a)) return this.memo.get(a);

      var _this$escapeMask = this.escapeMask(s),
          i = _this$escapeMask.mask,
          h = _this$escapeMask.escaped,
          r = [],
          k = this.opts.tokens != null ? this.opts.tokens : {},
          l = this.isReversed() ? -1 : 1,
          u = this.isReversed() ? "unshift" : "push",
          g = this.isReversed() ? 0 : i.length - 1,
          C = this.isReversed() ? function () {
        return o > -1 && c > -1;
      } : function () {
        return o < i.length && c < t.length;
      },
          S = function S(f) {
        return !_this2.isReversed() && f <= g || _this2.isReversed() && f >= g;
      };

      var E,
          d = -1,
          o = this.isReversed() ? i.length - 1 : 0,
          c = this.isReversed() ? t.length - 1 : 0;

      for (; C();) {
        var f = i.charAt(o),
            p = k[f],
            M = (p == null ? void 0 : p.transform) != null ? p.transform(t.charAt(c)) : t.charAt(c);

        if (!h.includes(o) && p != null) {
          if (M.match(p.pattern) != null) r[u](M), p.repeated ? (d === -1 ? d = o : o === g && o !== d && (o = d - l), g === d && (o -= l)) : p.multiple && (o -= l), o += l;else if (p.multiple) {
            var P = ((A = r[c - l]) == null ? void 0 : A.match(p.pattern)) != null,
                R = i.charAt(o + l);
            P && R !== "" && k[R] == null ? (o += l, c -= l) : r[u]("");
          } else M === E ? E = void 0 : p.optional && (o += l, c -= l);
          c += l;
        } else e && !this.isEager() && r[u](f), M === f && !this.isEager() ? c += l : E = f, this.isEager() || (o += l);

        if (this.isEager()) for (; S(o) && (k[i.charAt(o)] == null || h.includes(o));) {
          e ? r[u](i.charAt(o)) : i.charAt(o) === t.charAt(c) && (c += l), o += l;
        }
      }

      return this.memo.set(a, r.join("")), this.memo.get(a);
    }
  }]);

  return w;
}();

var V = function V(n) {
  return JSON.parse(n.replaceAll("'", '"'));
},
    T = function T(n) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var s = _objectSpread({}, t);

  return n.dataset.maska != null && n.dataset.maska !== "" && (s.mask = L(n.dataset.maska)), n.dataset.maskaEager != null && (s.eager = y(n.dataset.maskaEager)), n.dataset.maskaReversed != null && (s.reversed = y(n.dataset.maskaReversed)), n.dataset.maskaTokensReplace != null && (s.tokensReplace = y(n.dataset.maskaTokensReplace)), n.dataset.maskaTokens != null && (s.tokens = x(n.dataset.maskaTokens)), s;
},
    y = function y(n) {
  return n !== "" ? !!JSON.parse(n) : !0;
},
    L = function L(n) {
  return n.startsWith("[") && n.endsWith("]") ? V(n) : n;
},
    x = function x(n) {
  if (n.startsWith("{") && n.endsWith("}")) return V(n);
  var t = {};
  return n.split("|").forEach(function (s) {
    var e = s.split(":");
    t[e[0]] = {
      pattern: new RegExp(e[1]),
      optional: e[2] === "optional",
      multiple: e[2] === "multiple",
      repeated: e[2] === "repeated"
    };
  }), t;
};

var J = /*#__PURE__*/function () {
  function J(t) {
    var _this3 = this;

    var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, J);

    m(this, "items", /* @__PURE__ */new Map());
    m(this, "beforeinputEvent", function (t) {
      var s = t.target,
          e = _this3.items.get(s);

      e.isEager() && "inputType" in t && t.inputType.startsWith("delete") && e.unmasked(s.value).length <= 1 && _this3.setMaskedValue(s, "");
    });
    m(this, "inputEvent", function (t) {
      if (t instanceof CustomEvent && t.type === "input" && t.detail != null && _typeof(t.detail) == "object" && "masked" in t.detail) return;

      var s = t.target,
          e = _this3.items.get(s),
          a = s.value,
          i = s.selectionStart,
          h = s.selectionEnd;

      var r = a;

      if (e.isEager()) {
        var k = e.masked(a),
            l = e.unmasked(a);
        l === "" && "data" in t && t.data != null ? r = t.data : l !== e.unmasked(k) && (r = l);
      }

      if (_this3.setMaskedValue(s, r), "inputType" in t && (t.inputType.startsWith("delete") || i != null && i < a.length)) try {
        s.setSelectionRange(i, h);
      } catch (_unused) {}
    });
    this.options = s, typeof t == "string" ? this.init(Array.from(document.querySelectorAll(t)), this.getMaskOpts(s)) : this.init("length" in t ? Array.from(t) : [t], this.getMaskOpts(s));
  }

  _createClass(J, [{
    key: "destroy",
    value: function destroy() {
      var _iterator = _createForOfIteratorHelper(this.items.keys()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var t = _step.value;
          t.removeEventListener("input", this.inputEvent), t.removeEventListener("beforeinput", this.beforeinputEvent);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.items.clear();
    }
  }, {
    key: "needUpdateOptions",
    value: function needUpdateOptions(t, s) {
      var e = this.items.get(t),
          a = new w(T(t, this.getMaskOpts(s)));
      return JSON.stringify(e.opts) !== JSON.stringify(a.opts);
    }
  }, {
    key: "needUpdateValue",
    value: function needUpdateValue(t) {
      var s = t.dataset.maskaValue;
      return s == null && t.value !== "" || s != null && s !== t.value;
    }
  }, {
    key: "getMaskOpts",
    value: function getMaskOpts(t) {
      var s = t.onMaska,
          e = t.preProcess,
          a = t.postProcess,
          i = _objectWithoutProperties(t, ["onMaska", "preProcess", "postProcess"]);

      return i;
    }
  }, {
    key: "init",
    value: function init(t, s) {
      var _iterator2 = _createForOfIteratorHelper(t),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var e = _step2.value;
          var a = new w(T(e, s));
          this.items.set(e, a), e.value !== "" && this.setMaskedValue(e, e.value), e.addEventListener("input", this.inputEvent), e.addEventListener("beforeinput", this.beforeinputEvent);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "setMaskedValue",
    value: function setMaskedValue(t, s) {
      var e = this.items.get(t);
      this.options.preProcess != null && (s = this.options.preProcess(s));
      var a = e.masked(s),
          i = e.unmasked(e.isEager() ? a : s),
          h = e.completed(s),
          r = {
        masked: a,
        unmasked: i,
        completed: h
      };
      s = a, this.options.postProcess != null && (s = this.options.postProcess(s)), t.value = s, t.dataset.maskaValue = s, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach(function (k) {
        return k(r);
      }) : this.options.onMaska(r)), t.dispatchEvent(new CustomEvent("maska", {
        detail: r
      })), t.dispatchEvent(new CustomEvent("input", {
        detail: r
      }));
    }
  }]);

  return J;
}();

var v = /* @__PURE__ */new WeakMap(),
    N = function N(n) {
  setTimeout(function () {
    var t;
    ((t = v.get(n)) == null ? void 0 : t.needUpdateValue(n)) === !0 && n.dispatchEvent(new CustomEvent("input"));
  });
},
    U = function U(n, t) {
  var s = n instanceof HTMLInputElement ? n : n.querySelector("input"),
      e = _objectSpread({}, t.arg);

  if (s == null || (s == null ? void 0 : s.type) === "file") return;
  N(s);
  var a = v.get(s);

  if (a != null) {
    if (!a.needUpdateOptions(s, e)) return;
    a.destroy();
  }

  if (t.value != null) {
    var i = t.value,
        h = function h(r) {
      i.masked = r.masked, i.unmasked = r.unmasked, i.completed = r.completed;
    };

    e.onMaska = e.onMaska == null ? h : Array.isArray(e.onMaska) ? [].concat(_toConsumableArray(e.onMaska), [h]) : [e.onMaska, h];
  }

  v.set(s, new J(s, e));
};

export { w as Mask, J as MaskInput, O as tokens, U as vMaska };